module.exports = __webpack_public_path__ + "img/zhengshu3.5a6b2efd.png";